import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import AnaliseOperacionalModal from '../../../../../components/AnaliseOperacionalModal/AnaliseOperacionalModal';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import GenericContent from '../../../../../components/CrudWithSteps/components/GenericContent';
import { CustomButton } from '../../../../../components/CustomButton';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import HistoricoAnaliseOperacionalModal from '../../../../../components/HistoricoAnaliseOperacionalModal/HistoricoAnaliseOperacionalModal';
import CloudDownloadIcon from '../../../../../components/Icons/CloudDownloadIcon';
import DoneIcon from '../../../../../components/Icons/DoneIcon';
import HistoryRoundedIcon from '../../../../../components/Icons/HistoryRoundedIcon';
import ProgressModal from '../../../../../components/ProgressModal/ProgressModal';
import { Row } from '../../../../../components/Row';
import TextEditor, {
  TEXT_EDITOR_TD_STYLE,
} from '../../../../../components/TextEditor/TextEditor';
import { CONTRATO_STATUS_EM_ANALISE } from '../../../../../library/ContratoStatus';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_ADITIVO_NAME,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_CONTRATO_NAME,
  CONTRATO_VERSAO_DISTRATO,
  CONTRATO_VERSAO_DISTRATO_NAME,
} from '../../../../../library/ContratoVersoes';
import { contratosRoute } from '../../../../../library/Routes';
import {
  downloadValidacaoContrato,
  contratoAssessorSendAnaliseOperacional,
} from '../../../../../store/modules/ContratosAssessoresActions';
import {
  changeModalProps,
  closeModal,
  openModal,
} from '../../../../../store/modules/ModalActions';
import {
  getElementID,
  getHTMLWithStyleInlineForQuerySelector,
} from '../../../../../utils/HTMLUtils';
import infoIcon from './../../../../../assets/images/svg/info-black-icon.svg';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import styles from './AnaliseOperacional.scss';

const rootClassName = styles.rootClassName;
const rootElementId = 'contrato-analise-operacional';

const INITIAL_STATE = {
  sending: false,
  html: '',
  downloadValidacaoModalKey: null,
  analiseOperacionalModalKey: null,
};

class AnaliseOperacional extends GenericContent {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
  }

  getActions = () => {
    return (
      <>
        <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-left'}
          ></Col>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-right'}
          >
            <CustomButton
              label={this.props.languageValues.cadastroContratoRevisoes}
              theme='pufvYellow'
              onClick={this.toRevisoes}
              rightIcon={<HistoryRoundedIcon />}
              disabled={this.revisoesIsDisabled()}
              counter={this.getRevisoesCounter()}
            />
          </Col>
        </Row>
        <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-left'}
          >
            <CustomButton
              label={
                this.props.languageValues.cadastroContratoDownloadValidacao
              }
              theme='pufvYellow'
              onClick={this.toDownloadValidacao}
              leftIcon={<CloudDownloadIcon />}
              disabled={this.downloadValidacaoIsDisabled()}
            />
          </Col>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-right'}
          >
            <CustomButton
              label={this.props.languageValues.cadastroContratoFinalizarRevisao}
              theme='pufvYellow'
              onClick={this.toFinalizar}
              rightIcon={<DoneIcon />}
              disabled={this.finalizarIsDisabled()}
            />
          </Col>
        </Row>
      </>
    );
  };

  getVersaoId = () => {
    switch (this.props.contratosAssessores.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.contratosAssessores.contratoEditing.idAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.contratosAssessores.contratoEditing.idDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.contratosAssessores.contratoEditing.idContrato;
    }
  };

  toRevisoes = () => {
    this.props.openModal(HistoricoAnaliseOperacionalModal, {
      utils: this.props.utils,
      historico:
        this.props.contratosAssessores.contratoEditing
          .historicoAnaliseOperacional,
    });
  };

  revisoesIsDisabled = () => {
    return (
      this.props.loading ||
      this.props.contratosAssessores.contratoEditing
        .loadingHistoricoAnaliseOperacional ||
      (this.getRevisoesCounter() ? false : true)
    );
  };

  getRevisoesCounter = () => {
    const counter =
      this.props.contratosAssessores.contratoEditing.historicoAnaliseOperacional
        .length;
    return !this.props.loading && counter > 0 ? counter : null;
  };

  getFileName = () => {
    let fileName = '';
    switch (this.props.contratosAssessores.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        fileName = CONTRATO_VERSAO_ADITIVO_NAME;
        break;
      case CONTRATO_VERSAO_DISTRATO:
        fileName = CONTRATO_VERSAO_DISTRATO_NAME;
        break;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        fileName = CONTRATO_VERSAO_CONTRATO_NAME;
        break;
    }
    return fileName + '-rascunho-data-' + moment().format('DD-MM');
  };

  closeDownloadModal = () => {
    this.props.closeModal(this.state.downloadValidacaoModalKey);
    this.setState({
      downloadValidacaoModalKey: null,
    });
  };

  onDownloadProgress = (event) => {
    const percent = (event.loaded * 1) / event.total;
    if (this.state.downloadValidacaoModalKey) {
      this.props.changeModalProps(this.state.downloadValidacaoModalKey, {
        percent: percent,
      });
    }
  };

  onDownloadSuccess = (resp) => {
    const blob = new Blob([resp.data], {
      type: 'application/pdf',
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = this.getFileName();
    link.class = 'hidden-button';
    document.body.appendChild(link);
    link.click();
    link.remove();

    this.closeDownloadModal();
    SnackbarUtils.enqueueSnackbar({
      message: this.props.languageValues.successDownloadDocumentoValidacao,
      options: {
        variant: 'success',
      },
    });
  };

  onDownloadError = (error) => {
    this.closeDownloadModal();
    SnackbarUtils.enqueueSnackbar({
      message:
        error.response.statusText ||
        this.props.languageValues.errorDownloadDocumentoValidacao,
      options: {
        variant: 'error',
      },
    });
  };

  toDownloadValidacao = () => {
    const downloadValidacaoModalKey = this.props.openModal(ProgressModal, {
      title:
        this.props.languageValues.cadastroContratoArquivosDownloadingValidacao,
      percent: 0,
    }).payload.key;

    this.setState(
      {
        downloadValidacaoModalKey,
      },
      () => {
        this.props.downloadValidacaoContrato(
          this.getVersaoId(),
          this.props.contratosAssessores.contratoEditing.versaoContrato,
          this.onDownloadProgress,
          (resp) => this.onDownloadSuccess(resp),
          this.onDownloadError
        );
      }
    );
  };

  downloadValidacaoIsDisabled = () => {
    return (
      this.props.loading ||
      !this.props.auth.userPermissions.contratos.assessor.analiseOperacional
        .edit ||
      this.props.contratosAssessores.contratoEditing.flgStatus === -1 ||
      this.props.contratosAssessores.contratoEditing.flgStatus !==
        CONTRATO_STATUS_EM_ANALISE
    );
  };

  changeSendingStatus = (status) => {
    return new Promise((resolve) => {
      if (this.state.sending !== status) {
        this.setState(
          {
            sending: status,
          },
          () => {
            resolve();
            if (this.state.analiseOperacionalModalKey)
              this.props.changeModalProps(
                this.state.analiseOperacionalModalKey,
                {
                  loading: this.state.sending,
                }
              );
          }
        );
      } else {
        resolve();
      }
    });
  };

  toSubmitReturnFromAnaliseOperacional = (text) => {
    this.changeSendingStatus(true).then(() => {
      this.props.contratoAssessorSendAnaliseOperacional(
        {
          idContrato: this.getVersaoId(),
          versaoContrato:
            this.props.contratosAssessores.contratoEditing.versaoContrato,
          htmlContrato: getHTMLWithStyleInlineForQuerySelector(
            this.state.html,
            [
              {
                querySelector: 'td',
                style: TEXT_EDITOR_TD_STYLE,
              },
            ]
          ),
          justificativa: text,
        },
        () => {
          SnackbarUtils.enqueueSnackbar({
            message:
              this.props.languageValues.successReturningAnaliseOperacional,
            options: {
              variant: 'success',
            },
          });
          this.props.closeModal(this.state.analiseOperacionalModalKey);
          this.props.history.push(contratosRoute.path);
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorReturningAnaliseOperacional,
            options: {
              variant: 'error',
            },
          });
          this.changeSendingStatus(false);
        }
      );
    });
  };

  toFinalizar = () => {
    const analiseOperacionalModalKey = this.props.openModal(
      AnaliseOperacionalModal,
      {
        loading: this.state.sending,
        title: this.props.languageValues.cadastroContratoFinalizarRevisao,
        descriptionLabel:
          this.props.languageValues
            .cadastroContratoAnaliseOperacionalJustificativa,
        submitCallback: (text) =>
          this.toSubmitReturnFromAnaliseOperacional(text),
        savedCallback: () => {
          this.props.history.push(contratosRoute.path);
        },
      }
    ).payload.key;

    this.setState({
      analiseOperacionalModalKey: analiseOperacionalModalKey,
    });
  };

  finalizarIsDisabled = () => {
    return (
      this.props.loading ||
      !this.props.auth.userPermissions.contratos.assessor.analiseOperacional
        .edit ||
      this.props.contratosAssessores.contratoEditing.flgStatus === -1 ||
      this.props.contratosAssessores.contratoEditing.flgStatus !==
        CONTRATO_STATUS_EM_ANALISE
    );
  };

  getTitle = () => {
    switch (this.props.contratosAssessores.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues
          .cadastroContratoAnaliseOperacionalAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues
          .cadastroContratoAnaliseOperacionalDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues
          .cadastroContratoAnaliseOperacionalContrato;
    }
  };

  isLocked = () => {
    return (
      this.state.sending ||
      this.props.loading ||
      this.props.contratosAssessores.loadingTemplateContrato
    );
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      newProps.contratosAssessores.loadingTemplateContrato !==
        this.props.contratosAssessores.loadingTemplateContrato &&
      !newProps.contratosAssessores.loadingTemplateContrato
    ) {
      this.setState({
        html: newProps.contratosAssessores.contratoEditing.templateContrato,
      });
    }
  }

  getMacros = () => {
    let macros = {};
    this.props.contratos.templateMacros.map((macro) => {
      macros[macro.macro.split('#').join('')] = macro.nome;
      return macro.macro;
    });
    return macros;
  };

  getGenericCardScreenProps = () => {
    return {
      containerProps: {
        className: rootClassName + '-card-container',
      },
      GenericCardProps: {
        id: getElementID(rootElementId, 'card'),
        className: rootClassName,
        title: (
          <CardTitle onClick={this.openStepsMenu}>{this.getTitle()}</CardTitle>
        ),
        actions: this.getActions(),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending: this.isLocked(),
      },
    };
  };

  render() {
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        <TextEditor
          withoutBorder={true}
          className={rootClassName + '-editor'}
          disabled={this.isLocked()}
          value={this.state.html}
          onChange={(value) => this.setState({ html: value })}
          beforeCustomButtons={[
            {
              iconURL: infoIcon,
              tooltip: 'Macros',
              exec: (editor, control, btn) => {
                editor.selection.insertHTML('#' + btn.args[0] + '#');
              },
              list: this.getMacros(),
            },
          ]}
        />
      </GenericCardScreen>
    );
  }
}

AnaliseOperacional.propTypes = {
  utils: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosAssessores: state.contratosAssessores,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
      closeModal,
      changeModalProps,
      downloadValidacaoContrato,
      contratoAssessorSendAnaliseOperacional,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AnaliseOperacional));
